const collections = document.querySelectorAll('.sub_collection__item');
const tabs = document.querySelectorAll('.sub-collection__tabs-item');
const filterValuePicker = document.querySelector('.sub_collection__item') ? document.querySelector('.sub_collection__item').getAttribute('data-filter-name') : '';
window.filterCollection = '';

function resetActiveFilter(filters) {
    filters.forEach(function (filter) {
        if (filter.checked && filter.getAttribute('name') === `${filterValuePicker}`) {
            filter.click();
        }
    });
}

if (collections.length) {
    collections.forEach(function (collection) {
        collection.addEventListener('click', function () {
            const isActive = collection.classList.contains('active');
            const tabId = collection.getAttribute('data-collection');
            const filters = document.querySelectorAll('#FacetFiltersContainer .filter_target');
            const filterValue = collection.getAttribute('data-filter');

            let matched = false;

            filters.forEach(function (filter) {
                if (filterValue === filter.getAttribute('data-filter')) {
                    if (filter.checked) {
                        resetActiveFilter(filters);
                    } else {
                        resetActiveFilter(filters);
                        window.filterCollection = filter.value;
                        filter.click();
                    }
                    matched = true;
                }
            });

            if (!matched) {
                resetActiveFilter(filters);
            }

            collections.forEach(item => item.classList.remove('active'));
            tabs.forEach(tab => tab.classList.remove('active'));

            if (!isActive) {
                collection.classList.add('active');
                tabs.forEach(function (tab) {
                    if (tab.getAttribute('data-collection') === tabId) {
                        tab.classList.add('active');
                        const rect = tab.getBoundingClientRect();
                        const offset = rect.top + window.pageYOffset - 80;
                        window.scrollTo({
                            top: offset,
                            behavior: 'smooth'
                        });
                    }
                });
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const filters = document.querySelectorAll('#FacetFiltersContainer .filter_target');

    filters.forEach(function (filter) {
        if (filter.checked) {
            const filterValue = filter.getAttribute('data-filter');

            collections.forEach(function (collection) {
                const collectionFilterValue = collection.getAttribute('data-filter');
                const tabId = collection.getAttribute('data-collection');

                if (collectionFilterValue === filterValue) {
                    collection.classList.add('active');

                    tabs.forEach(function (tab) {
                        if (tab.getAttribute('data-collection') === tabId) {
                            tab.classList.add('active');
                        }
                    });
                }
            });
        }
    });
});